import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  ButtonGroup,
  Chip,
  Divider,
  FormLabel,
  Typography,
} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import GlobalDateField from "../../global-fields/GlobalDateField";
import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import GlobalTextField from "../../global-fields/GlobalTextField";
import {useFormik} from "formik";
import * as Yup from "yup";
import NewProposalFooter from "./NewProposalFooter";
import GlobalSelectField from "../../global-fields/GlobalSelectField";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {selectAuthState} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {setUiData} from "../../../store/uiSlice";
import {PROPOSAL_FORM} from "../../../constants/apiConstant";
import {MANDATORY_QUES} from "../../../constants/constants";
import {
  initialFormValidations,
  normalizeCurrencyToNumber,
  parseToNumber,
  parseToNumberVersion2,
  removeCookies,
  USD_FORMATTER,
} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import GlobalModal from "../../global-fields/GlobalModal";
import {IoMdClose} from "react-icons/io";
import GlobalErrorMsgBox from "../../global-fields/GlobalErrorMsgBox";
import {motion} from "framer-motion";
import {fadeSlideIn} from "../../../constants/motionConstants";
import dayjs from "dayjs";
import {
  amountSchemaWithoutRequired,
  amountSchemaWithRequired,
  numberSchema,
  numberSchemaWithPercentage,
  numberSchemaWithPercentageWithoutRequired,
  optionalAmountSchema,
  optionalNumberSchemaWithPercentage,
} from "../../../constants/validationSchemas";
import plusIcon from "../../../assets/img/proposal-img/plus_icon.svg";
import minusIcon from "../../../assets/img/proposal-img/minus_icon.svg";

const BankTrustSafeMenuItems = [
  {name: "Bank", value: "Bank"},
  {name: "Trust", value: "Trust"},
  {name: "Safe Deposit", value: "Safe Deposit"},
];

const StepFiveForm = ({leftGridWidth}) => {
  const PremisesLimit = 10;
  const nameAddressTypeLimit = 4;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, selectedClient} = useSelector(selectAuthState);
  const {
    proposalStep,
    propStep5Data,
    proposal_id,
    previous_proposal_id,
    editingSubmitted,
    formValidations,
  } = useSelector(selectDataStoreState);
  const [openModal, setOpenModal] = useState(false);
  const [sum_stock_percentage_err, setSum_stock_percentage_err] = useState({});
  const [sum_jewelry_watches_err, setSum_jewelry_watches_err] = useState({});
  const [totalErrors, setTotalErrors] = useState({});
  const [disableDraft, setDisableDraft] = useState(false);
  const [modalContent, setModalContent] = useState("");
  //const [totalPremises, //setTotalPremises] = useState(1);
  const selectRefs = useRef({});
  const propStep5DataMemoize = useMemo(() => propStep5Data, [propStep5Data]);

  const initialValues = useMemo(
    () => ({
      step: 5,
      warranty_premises: propStep5DataMemoize?.warranty_premises?.length
        ? propStep5DataMemoize?.warranty_premises?.map((item) => ({
            minimum_locked_safes:
              item.minimum_locked_safes == 0 ||
              item.minimum_locked_safes == "0" ||
              item.minimum_locked_safes
                ? USD_FORMATTER.format(item.minimum_locked_safes)
                : "",
            minimum_other_locked_safes:
              item.minimum_other_locked_safes == 0 ||
              item.minimum_other_locked_safes == "0" ||
              item.minimum_other_locked_safes
                ? USD_FORMATTER.format(item.minimum_other_locked_safes)
                : "",
            maximum_property_value:
              item.maximum_property_value == 0 ||
              item.maximum_property_value == "0" ||
              item.maximum_property_value
                ? USD_FORMATTER.format(item.maximum_property_value)
                : "",
            maximum_property_value_in_bank:
              item.maximum_property_value_in_bank == 0 ||
              item.maximum_property_value_in_bank == "0" ||
              item.maximum_property_value_in_bank
                ? USD_FORMATTER.format(item.maximum_property_value_in_bank)
                : "",

            // minimum_locked_safes: item.minimum_locked_safes,
            // minimum_other_locked_safes: item.minimum_other_locked_safes,
            // maximum_property_value: item.maximum_property_value,
            // total: item.total,
            // maximum_property_value_in_bank:
            //   item.maximum_property_value_in_bank == 0 ||
            //     item.maximum_property_value_in_bank == "0"
            //     ? "0"
            //     : item.maximum_property_value_in_bank,
            name_address_type: item.name_address_type?.map((nat) => ({
              name: nat.name || "",
              address: nat.address || "",
              type: nat.type || "",
            })) || [
              {
                name: "",
                address: "",
                type: "",
              },
            ],
          }))
        : [
            {
              minimum_locked_safes: "",
              minimum_other_locked_safes: "",
              maximum_property_value: "",
              total: "",
              maximum_property_value_in_bank: "",
              name_address_type: [
                {
                  name: "",
                  address: "",
                  type: "",
                },
              ],
            },
          ],
      inventories_premises: propStep5DataMemoize?.inventories_premises?.length
        ? propStep5DataMemoize?.inventories_premises?.map((item) => ({
            last_merchandise_date: item.last_merchandise_date,
            last_merchandise_amount:
              item.last_merchandise_amount == 0 ||
              item.last_merchandise_amount == "0" ||
              item.last_merchandise_amount
                ? USD_FORMATTER.format(item.last_merchandise_amount)
                : "",
            previous_merchandise_date: item.previous_merchandise_date,
            previous_merchandise_amount:
              item.previous_merchandise_amount == 0 ||
              item.previous_merchandise_amount == "0" ||
              item.previous_merchandise_amount
                ? USD_FORMATTER.format(item.previous_merchandise_amount)
                : "",
            maximum_stock_amount:
              item.maximum_stock_amount == 0 ||
              item.maximum_stock_amount == "0" ||
              item.maximum_stock_amount
                ? USD_FORMATTER.format(item.maximum_stock_amount)
                : "",
            pawnbrokers_amount:
              item.pawnbrokers_amount == 0 ||
              item.pawnbrokers_amount == "0" ||
              item.pawnbrokers_amount
                ? USD_FORMATTER.format(item.pawnbrokers_amount)
                : "",
            average_daily_amount:
              item.average_daily_amount == 0 ||
              item.average_daily_amount == "0" ||
              item.average_daily_amount
                ? USD_FORMATTER.format(item.average_daily_amount)
                : "",
            loose_diamonds: item.loose_diamonds,
            pearls_natural_cultured: item.pearls_natural_cultured,
            other_unset_precious_stone: item.other_unset_precious_stone,
            unset_semi_precious_stone: item.unset_semi_precious_stone,
            jewelry_mounted: item.jewelry_mounted,
            other_jewelry: item.other_jewelry,
            watches_with_diamonds: item.watches_with_diamonds,
            other_watches: item.other_watches,
            clocks: item.clocks,
            silveware_pewter_steels: item.silveware_pewter_steels,
            jewelry_findings: item.jewelry_findings,
            all_other_stock: item.all_other_stock,
            stock_describe: item.stock_describe,
            jewelry_percentage: item.jewelry_percentage,
            watches_clocks_percentage: item.watches_clocks_percentage,
          }))
        : [
            {
              last_merchandise_date: "",
              last_merchandise_amount: "",
              previous_merchandise_date: "",
              previous_merchandise_amount: "",
              maximum_stock_amount: "",
              pawnbrokers_amount: "",
              average_daily_amount: "",
              loose_diamonds: "",
              pearls_natural_cultured: "",
              other_unset_precious_stone: "",
              unset_semi_precious_stone: "",
              jewelry_mounted: "",
              other_jewelry: "",
              watches_with_diamonds: "",
              other_watches: "",
              clocks: "",
              silveware_pewter_steels: "",
              jewelry_findings: "",
              all_other_stock: "",
              stock_describe: "",
              jewelry_percentage: "",
              watches_clocks_percentage: "",
            },
          ],
      property_premises: propStep5DataMemoize?.property_premises?.length
        ? propStep5DataMemoize?.property_premises?.map((item) => ({
            cash_value:
              item.cash_value == 0 || item.cash_value == "0" || item.cash_value
                ? USD_FORMATTER.format(item.cash_value)
                : "",
            furniture_other: item.furniture_other?.toString() || "",
            tentants_improvements: item.tentants_improvements?.toString() || "",
          }))
        : [{cash_value: "", furniture_other: "", tentants_improvements: ""}],
    }),
    [propStep5DataMemoize]
  );

  // useEffect(() => {
  //   if (propStep5DataMemoize) {
  //     formik.setValues(initialValues);
  //   }
  // }, [propStep5DataMemoize]);

  const handleStepData = (e) => {
    if (!proposal_id) {
      GlobalNotificationPopup({
        type: "error",
        message: "Please Fillout Initial/Business Details Form First.",
      });
      return;
    }
    dispatch(setUiData({showLoader: true}));
    // if (key === "certificate_expiry_date") {
    //                     formData.append(key, dayjs(value).format("MM-DD-YYYY"))
    //                 }
    const cleanAmountFields = (item, fields) => {
      const cleanedItem = {...item};
      fields.forEach((field) => {
        if (cleanedItem[field] !== undefined) {
          cleanedItem[field] = normalizeCurrencyToNumber(cleanedItem[field]);
        }
      });
      return cleanedItem;
    };

    let data = {
      ...e,
      user_id: user?.id,
      proposal_id,
      proposal_status: editingSubmitted ? 1 : 0,
      previous_proposal_id: previous_proposal_id ?? null,
      step: proposalStep,
      inventories_premises: e?.inventories_premises?.map((item) =>
        cleanAmountFields(
          {
            ...item,
            last_merchandise_date: item.last_merchandise_date
              ? dayjs(item.last_merchandise_date).format("MM-DD-YYYY")
              : "",
            previous_merchandise_date: item.previous_merchandise_date
              ? dayjs(item.previous_merchandise_date).format("MM-DD-YYYY")
              : "",
          },
          [
            "last_merchandise_amount",
            "previous_merchandise_amount",
            "maximum_stock_amount",
            "pawnbrokers_amount",
            "average_daily_amount",
          ]
        )
      ),
      warranty_premises: e?.warranty_premises?.map((item) =>
        cleanAmountFields(item, [
          "maximum_property_value",
          "maximum_property_value_in_bank",
          "minimum_locked_safes",
          "minimum_other_locked_safes",
        ])
      ),
      property_premises: e?.property_premises?.map((item) =>
        cleanAmountFields(item, ["cash_value"])
      ),
    };
    if (user?.user_type === "agent") {
      data = {...data, user_id: selectedClient?.user_id, agent_id: user?.id};
    }
    // let data = {
    //   ...e,
    //   user_id: user?.id,
    //   proposal_id,
    //   step: proposalStep,
    //   inventories_premises: e?.inventories_premises?.map((item) => ({
    //     ...item,
    //     last_merchandise_date: item.last_merchandise_date
    //       ? dayjs(item.last_merchandise_date).format("MM-DD-YYYY")
    //       : "",
    //     previous_merchandise_date: item.previous_merchandise_date
    //       ? dayjs(item.previous_merchandise_date).format("MM-DD-YYYY")
    //       : "",
    //   })),
    // };

    const options = {
      method: PROPOSAL_FORM.method,
      headers: PROPOSAL_FORM.headers,
      body: JSON.stringify(data),
    };

    fetch(PROPOSAL_FORM.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(setUiData({showLoader: false}));
          formik.resetForm();
        } else if (res.status == 1) {
          formik.resetForm();
          dispatch(
            setDataStore({
              proposalStep: proposalStep + 1,
            })
          );
          dispatch(setUiData({showLoader: false}));
        }
        if (e?.save_draft) {
          setDisableDraft(false);
        }
      })
      .catch((error) => {
        dispatch(
          setDataStore({
            proposalStep: 1,
            proposal_id: null,
            previous_proposal_id: null,
            editingSubmitted: false,
            clickedSteps: [],
            formValidations: initialFormValidations,
          })
        );
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(setUiData({showLoader: false}));
        navigate("/");
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      warranty_premises: Yup.array().of(
        Yup.object().shape({
          minimum_locked_safes: amountSchemaWithoutRequired,
          minimum_other_locked_safes: amountSchemaWithoutRequired,
          maximum_property_value: amountSchemaWithoutRequired,
          //total: Yup.string().required(MANDATORY_QUES),
          // .test("total-sum", "Total must be exactly 100%", function (value) {
          //   const {
          //     minimum_locked_safes = 0,
          //     minimum_other_locked_safes = 0,
          //     maximum_property_value = 0,
          //   } = this.parent;

          //   // ✅ Calculate total sum
          //   const totalSum =
          //     minimum_locked_safes +
          //     minimum_other_locked_safes +
          //     maximum_property_value;

          //   // ✅ Return true only if totalSum is 100
          //   return totalSum === 100;
          // }),

          // total: Yup.number()
          //   .required(MANDATORY_QUES)
          //   .test("total-sum", "", function (value) {
          //     const {
          //       minimum_locked_safes = 0,
          //       minimum_other_locked_safes = 0,
          //       maximum_property_value = 0,
          //     } = this.parent;
          //     return (
          //       value ===
          //       minimum_locked_safes +
          //       minimum_other_locked_safes +
          //       maximum_property_value
          //     );
          //   })
          //   .min(100, "Total must be equal to 100%")
          //   .max(100, "Total must not exceed 100%"),
          maximum_property_value_in_bank: amountSchemaWithoutRequired,
          name_address: Yup.array().of(
            Yup.object({
              name: Yup.string()
                .nullable()
                .when(
                  "maximum_property_value_in_bank",
                  (maximum_property_value_in_bank, schema) => {
                    return normalizeCurrencyToNumber(
                      maximum_property_value_in_bank
                    ) != 0 &&
                      normalizeCurrencyToNumber(
                        maximum_property_value_in_bank
                      ) > 0
                      ? schema.required(MANDATORY_QUES)
                      : schema;
                  }
                ),
              address: Yup.string()
                .nullable()
                .when(
                  "maximum_property_value_in_bank",
                  (maximum_property_value_in_bank, schema) => {
                    return normalizeCurrencyToNumber(
                      maximum_property_value_in_bank
                    ) != 0 &&
                      normalizeCurrencyToNumber(
                        maximum_property_value_in_bank
                      ) > 0
                      ? schema.required(MANDATORY_QUES)
                      : schema.nullable();
                  }
                ),
              type: Yup.string()
                .nullable()
                .when(
                  "maximum_property_value_in_bank",
                  (maximum_property_value_in_bank, schema) => {
                    return normalizeCurrencyToNumber(
                      maximum_property_value_in_bank
                    ) != 0 &&
                      normalizeCurrencyToNumber(
                        maximum_property_value_in_bank
                      ) > 0
                      ? schema.required(MANDATORY_QUES)
                      : schema;
                  }
                ),
            })
          ),
        })
      ),
      inventories_premises: Yup.array().of(
        Yup.object().shape({
          last_merchandise_date: Yup.string(),
          last_merchandise_amount: optionalAmountSchema,
          previous_merchandise_date: Yup.string(),
          previous_merchandise_amount: optionalAmountSchema,
          maximum_stock_amount: optionalAmountSchema,
          pawnbrokers_amount: optionalAmountSchema,
          average_daily_amount: optionalAmountSchema,
          loose_diamonds: optionalNumberSchemaWithPercentage,
          pearls_natural_cultured: optionalNumberSchemaWithPercentage,
          other_unset_precious_stone: optionalNumberSchemaWithPercentage,
          unset_semi_precious_stone: optionalNumberSchemaWithPercentage,
          jewelry_mounted: optionalNumberSchemaWithPercentage,
          other_jewelry: optionalNumberSchemaWithPercentage,
          watches_with_diamonds: optionalNumberSchemaWithPercentage,
          other_watches: optionalNumberSchemaWithPercentage,
          clocks: optionalNumberSchemaWithPercentage,
          silveware_pewter_steels: optionalNumberSchemaWithPercentage,
          jewelry_findings: optionalNumberSchemaWithPercentage,
          all_other_stock: optionalNumberSchemaWithPercentage,
          //stock_describe: Yup.string().notRequired().nullable(),

          stock_describe: Yup.string()
            .nullable()
            .when("all_other_stock", (all_other_stock, schema) => {
              return all_other_stock &&
                Number(all_other_stock) != 0 &&
                Number(all_other_stock) > 0
                ? schema.required(MANDATORY_QUES)
                : Yup.string().notRequired().nullable();
            }),

          jewelry_percentage: optionalNumberSchemaWithPercentage,
          watches_clocks_percentage: optionalNumberSchemaWithPercentage,
        })
      ),
      // property_premises: Yup.array().of(
      //   Yup.object()
      //     .shape({
      //       cash_value: amountSchemaWithRequired,
      //       furniture_other: Yup.number().when(
      //         "cash_value",
      //         (cash_value, schema) => {
      //           return cash_value > 0 ? numberSchemaWithPercentage : schema;
      //         }
      //       ),
      //       tentants_improvements: Yup.number().when(
      //         "cash_value",
      //         (cash_value, schema) => {
      //           return cash_value > 0 ? numberSchemaWithPercentage : schema;
      //         }
      //       ),
      //     })
      //     .test(
      //       "sum-must-be-100",
      //       "The Total % of 'Furniture...' & 'Tenant’s Impro...' must be exactly 100%",
      //       function (values) {
      //         const {
      //           furniture_other = 0,
      //           tentants_improvements = 0,
      //           cash_value = 0,
      //         } = values;
      //         if (cash_value == 0) return true;
      //         return (
      //           Number(furniture_other) + Number(tentants_improvements) === 100
      //         );
      //       }
      //     )
      // ),
      // property_premises: Yup.array().of(
      //   Yup.object()
      //     .shape({
      //       cash_value: amountSchemaWithRequired,
      //       furniture_other: Yup.number().when(
      //         "cash_value",
      //         (cash_value, schema) => {
      //           return cash_value > 0
      //             ? numberSchemaWithPercentageWithoutRequired
      //             : schema.notRequired();
      //         }
      //       ),
      //       tentants_improvements: Yup.number().when(
      //         "cash_value",
      //         (cash_value, schema) => {
      //           return cash_value > 0
      //             ? numberSchemaWithPercentageWithoutRequired
      //             : schema.notRequired();
      //         }
      //       ),
      //     })
      //     .test(
      //       "sum-must-be-100",
      //       "The Total % of 'Furniture...' & 'Tenant’s Impro...' must be exactly 100%",
      //       function (values) {
      //         const {
      //           furniture_other = 0,
      //           tentants_improvements = 0,
      //           cash_value = 0,
      //         } = values || {};
      //         // ✅ Skip test if cash_value is 0 or falsy
      //         if (
      //           cash_value === "$0" ||
      //           !cash_value ||
      //           Number(cash_value) == 0
      //         ) {
      //           return true;
      //         }

      //         const total =
      //           Number(furniture_other) + Number(tentants_improvements);
      //         return total === 100;
      //       }
      //     )
      // ),
      property_premises: Yup.array().of(
        Yup.object().shape({
          cash_value: optionalAmountSchema,

          furniture_other: optionalNumberSchemaWithPercentage,

          tentants_improvements: optionalNumberSchemaWithPercentage,

          // furniture_other: Yup.number()
          //   .nullable()
          //   .transform((value) => (isNaN(value) ? undefined : value)),

          // tentants_improvements: Yup.number()
          //   .nullable()
          //   .transform((value) => (isNaN(value) ? undefined : value)),
        })
        // .test(
        //   "sum-max-100",
        //   "The total % of 'Furniture' and 'Tenant’s Improvements' must not exceed 100%",
        //   function (values) {
        //     const { furniture_other = 0, tentants_improvements = 0 } =
        //       values || {};

        //     // If both are undefined or empty, skip validation
        //     if (
        //       (furniture_other === undefined ||
        //         furniture_other === null ||
        //         furniture_other === "") &&
        //       (tentants_improvements === undefined ||
        //         tentants_improvements === null ||
        //         tentants_improvements === "")
        //     ) {
        //       return true;
        //     }

        //     const total =
        //       Number(furniture_other || 0) +
        //       Number(tentants_improvements || 0);
        //     return total <= 100;
        //   }
        // )
      ),
    }),
    onSubmit: (values) => {
      let allValid = true; // Flag to track if everything is valid

      // Loop through inventories_premises and validate each item
      values.inventories_premises?.forEach((item, index) => {
        const {
          loose_diamonds = 0,
          pearls_natural_cultured = 0,
          other_unset_precious_stone = 0,
          unset_semi_precious_stone = 0,
          jewelry_mounted = 0,
          other_jewelry = 0,
          watches_with_diamonds = 0,
          other_watches = 0,
          clocks = 0,
          silveware_pewter_steels = 0,
          jewelry_findings = 0,
          all_other_stock = 0,
          jewelry_percentage = 0,
          watches_clocks_percentage = 0,
        } = item;

        // Calculate total stock sum for each item
        const totalStockSum =
          Number(loose_diamonds) +
          Number(pearls_natural_cultured) +
          Number(other_unset_precious_stone) +
          Number(unset_semi_precious_stone) +
          Number(jewelry_mounted) +
          Number(other_jewelry) +
          Number(watches_with_diamonds) +
          Number(other_watches) +
          Number(clocks) +
          Number(silveware_pewter_steels) +
          Number(jewelry_findings) +
          Number(all_other_stock) +
          Number(jewelry_percentage) +
          Number(watches_clocks_percentage);
        // Calculate total jewelry and watches/clocks sum for each item
        const totalJewelryWatchSum =
          Number(jewelry_percentage) + Number(watches_clocks_percentage);
        // console.log(
        //   "totalJewelryWatchSum",
        //   totalStockSum,
        //   totalJewelryWatchSum
        // );
        //  Validate Stock Percentage Sum
        if (totalStockSum !== 100) {
          allValid = true;
          setSum_stock_percentage_err((prev) => ({
            ...prev,
            [index]: false,
          }));
          // GlobalNotificationPopup({
          //   type: "error",
          //   message: `Stock percentages in Premise ${index + 1} must be equal to 100%.`,
          // });
        } else {
          setSum_stock_percentage_err((prev) => ({
            ...prev,
            [index]: false,
          }));
        }

        //  Validate Jewelry + Watches/Clocks Sum
        // if (totalJewelryWatchSum !== 100) {
        //   allValid = false;
        //   setSum_jewelry_watches_err((prev) => ({
        //     ...prev,
        //     [index]: true,
        //   }));
        //   GlobalNotificationPopup({
        //     type: "error",
        //     message: `The sum of 'Jewelry %' and 'Watches/Clocks %' in Premise ${
        //       index + 1
        //     } must be equal to 100%.`,
        //   });
        // } else {
        //   setSum_jewelry_watches_err((prev) => ({
        //     ...prev,
        //     [index]: false,
        //   }));
        // }
      });
      let errorFounded =
        totalErrors && Object.values(totalErrors).some((e) => e === true);

      if (errorFounded) {
        GlobalNotificationPopup({
          type: "error",
          message: `Total must be equal to 100% in the Proportions by value of property on premises.`,
        });
        return;
      }
      //  Proceed only if all validations pass
      if (allValid && !errorFounded) {
        //console.log("Form submitted 5:", values);
        handleStepData(values); // Continue to the next step
      }
    },
  });
  // console.log("formikkkk", totalErrors);
  // console.log("loose_diamonds",totalErrors,formik.values,formik.errors );
  const handleCustomSubmit = async (e) => {
    const errors = await formik.validateForm();

    if (Object.keys(errors).length > 0) {
      const updated = formValidations.map((item) => {
        if (item.step === 5) {
          return {...item, status: 2};
        }
        return item;
      });

      dispatch(
        setDataStore({
          formValidations: updated,
        })
      );

      formik.handleSubmit(); // still runs to show errors
    } else {
      formik.handleSubmit(); // successful submit
    }
  };
  const handlePlus = useCallback(() => {
    //setTotalPremises((prev) => prev + 1);
    formik.setValues((prevValues) => ({
      warranty_premises: [
        ...prevValues?.warranty_premises,
        {
          minimum_locked_safes: "",
          minimum_other_locked_safes: "",
          maximum_property_value: "",
          total: "",
          maximum_property_value_in_bank: "",
          // name: "",
          // address: "",
          // type: "",
          name_address_type: [
            {
              name: "",
              address: "",
              type: "",
            },
          ],
        },
      ],
      inventories_premises: [
        ...prevValues?.inventories_premises,
        {
          last_merchandise_date: "",
          last_merchandise_amount: "",
          previous_merchandise_date: "",
          previous_merchandise_amount: "",
          maximum_stock_amount: "",
          pawnbrokers_amount: "",
          average_daily_amount: "",
          loose_diamonds: "",
          pearls_natural_cultured: "",
          other_unset_precious_stone: "",
          unset_semi_precious_stone: "",
          jewelry_mounted: "",
          other_jewelry: "",
          watches_with_diamonds: "",
          other_watches: "",
          clocks: "",
          silveware_pewter_steels: "",
          jewelry_findings: "",
          all_other_stock: "",
          stock_describe: "",
          jewelry_percentage: "",
          watches_clocks_percentage: "",
        },
      ],
      property_premises: [
        ...prevValues?.property_premises,
        {cash_value: "", furniture_other: "", tentants_improvements: ""},
      ],
    }));
  }, [formik]);

  const handleRemove = useCallback(
    (val) => {
      if (!val) {
        setOpenModal(false);
        setModalContent("");
        return;
      }
      //setTotalPremises((prev) => Math.max(prev - 1, 1)); // Ensures it never goes below 1
      formik.setValues((prevValues) => ({
        warranty_premises:
          prevValues?.warranty_premises.length > 1
            ? prevValues?.warranty_premises.slice(0, -1)
            : prevValues?.warranty_premises,
        inventories_premises:
          prevValues?.inventories_premises.length > 1
            ? prevValues?.inventories_premises.slice(0, -1)
            : prevValues?.inventories_premises,
        property_premises:
          prevValues?.property_premises.length > 1
            ? prevValues?.property_premises.slice(0, -1)
            : prevValues?.property_premises,
      }));

      // TOTAL ERRORS --
      // let errsObj = { ...totalErrors };

      // // Loop through keys and delete errors at the last index
      // Object.keys(errsObj).forEach((key) => {
      //   if (Array.isArray(errsObj[key])) {
      //     errsObj[key].pop(); // Removes error from last index
      //   } else {
      //     delete errsObj[key]; // Remove if it's not an array (fallback)
      //   }
      // });

      // setTotalErrors(errsObj);
      setOpenModal(false);
      setModalContent("");
    },
    [formik]
  );

  const handleConfirmation = (index, type) => {
    setOpenModal(true);
    setModalContent(
      `You Want To Remove Premise ${index ? index + 1 : ""} -  Warranties, Inventories & Properties.`
    );
  };

  const handleChangeAndUpdateTotal = (index, field, value) => {
    const warrantyPremises = [...formik.values.warranty_premises];

    // Update the current field value as-is (don't convert to Number yet)
    warrantyPremises[index][field] = value;

    // Safe number parser: only parse if it's a valid number string
    const parseSafeNumber = (val) => {
      const num = Number(val);
      return !isNaN(num) && Number.isFinite(num) ? num : 0;
    };

    // Use safe parsing for calculation
    const minimum_locked_safes = parseSafeNumber(
      warrantyPremises[index].minimum_locked_safes
    );
    const minimum_other_locked_safes = parseSafeNumber(
      warrantyPremises[index].minimum_other_locked_safes
    );
    const maximum_property_value = parseSafeNumber(
      warrantyPremises[index].maximum_property_value
    );
    const maximum_property_value_in_bank = parseSafeNumber(
      warrantyPremises[index].maximum_property_value_in_bank
    );

    const totalSum =
      minimum_locked_safes +
      minimum_other_locked_safes +
      maximum_property_value +
      maximum_property_value_in_bank;

    // ✅ Update total field
    warrantyPremises[index].total = totalSum;

    // // ✅ Set updated values in Formik
    // formik.setValues({
    //   ...formik.values,
    //   warranty_premises: warrantyPremises,
    // });
    formik.setValues((prevValues) => ({
      ...prevValues,
      warranty_premises: warrantyPremises,
    }));
    // ✅ Error handling for total
    // if (totalSum !== 100) {
    //   formik.setFieldError(
    //     `warranty_premises[${index}].total`,
    //     "Total must be exactly 100%"
    //   );
    //   setTotalErrors((prev) => ({
    //     ...prev,
    //     [index]: true,
    //   }));
    // } else {
    //   formik.setFieldError(`warranty_premises[${index}].total`, undefined);
    //   setTotalErrors((prev) => ({
    //     ...prev,
    //     [index]: false,
    //   }));
    // }
  };

  const handlePropertyChange = (e, index, fieldName) => {
    const {name, value} = e.target;
    const newValue = value == "0" ? 0 : parseFloat(value) || "";

    formik.setFieldValue(name, newValue);

    // if (fieldName === "furniture_other" && newValue === 100) {
    //   formik.setFieldValue(
    //     `property_premises[${index}].tentants_improvements`,
    //     0
    //   );
    // }

    // if (fieldName === "tentants_improvements" && newValue === 100) {
    //   formik.setFieldValue(`property_premises[${index}].furniture_other`, 0);
    // }
  };
  const handleAmountFieldChangeOLD = (e, index, fieldName) => {
    const rawValue = e.target.value;
    const numericValue = parseToNumber(rawValue);
    formik.setFieldValue(
      fieldName,
      numericValue !== "" ? USD_FORMATTER.format(numericValue) : ""
    );
  };
  const handleAmountFieldChange = (e, index, fieldName) => {
    let rawValue = e.target.value;

    // Ensure it always starts with $
    if (!rawValue.startsWith("$")) rawValue = "$" + rawValue;

    // Extract numeric part
    const numericValue = parseToNumber(rawValue);

    // Allow typing "$" or "$." without formatting
    if (rawValue === "$" || rawValue === "$.") {
      formik.setFieldValue(fieldName, rawValue);
      return;
    }

    // Format integer part with commas, keep decimal part as typed
    let formatted = "$";
    if (numericValue !== "") {
      const [integerPart, decimalPart] = rawValue
        .replace(/[^0-9.]/g, "")
        .split(".");

      // Format integer with commas
      formatted += new Intl.NumberFormat("en-US").format(Number(integerPart));

      // Append decimal part if exists, limit to 2 digits
      if (decimalPart !== undefined) {
        formatted += "." + decimalPart.slice(0, 2);
      }
    }

    formik.setFieldValue(fieldName, formatted);
  };

  const handlePlusNameAddress = (index) => {
    const nameAddressList =
      formik.values?.warranty_premises[index].name_address_type;

    // Get the last entry
    const lastEntry = nameAddressList[nameAddressList.length - 1];
    console.log("ainimeanraiwen", nameAddressList, lastEntry);
    // Check if the last entry is fully filled
    if (
      !lastEntry ||
      lastEntry.name.trim() === "" ||
      lastEntry.address.trim() === "" ||
      lastEntry.type.trim() === ""
    ) {
      //   alert("Please fill the last Name and Address fields before adding a new one.");
      GlobalNotificationPopup({
        type: "warning",
        message: "Please fill all fields before adding a new entry.",
      });
      return;
    }

    if (nameAddressList.length < nameAddressTypeLimit) {
      formik.setFieldValue(`warranty_premises[${index}].name_address_type`, [
        ...nameAddressList,
        {
          name: "",
          address: "",
          type: "",
        },
      ]);
    }
  };
  const handleMinusNameAddress = (index, addressIndex) => {
    // if (
    //   formik.values?.warranty_premises[index].name_address_type.length >
    //   nameAddressTypeLimit
    // ) {
    const updatedAddresses = formik.values?.warranty_premises[
      index
    ].name_address_type.filter((_, i) => i !== addressIndex);
    formik.setFieldValue(
      `warranty_premises[${index}].name_address_type`,
      updatedAddresses
    );
    //}
  };
  console.log(
    "FORMIKKKKK",
    formik.values,
    formik.errors,
    parseToNumberVersion2("$0"),
    parseToNumberVersion2(""),
    parseToNumberVersion2("$12,385")
  );
  const handleSaveDraft = useCallback(() => {
    const {values} = formik;
    setDisableDraft(true);
    let vals = {...values, save_draft: true};
    // console.log("vals", vals);
    //return;
    handleStepData(vals);
  }, [formik]);

  return (
    <>
      <section className={style.proposalMain}>
        <motion.div {...fadeSlideIn}>
          <Box className={style.proposalMainD}>
            {selectedClient !== null ? (
              <div className={style.client_title}>
                <p> On behalf of Client : </p>
                <h3>
                  {selectedClient?.first_name} {selectedClient?.last_name}{" "}
                </h3>
                {/* <span>{selectedClient?.email} </span> */}
                <Divider />
              </div>
            ) : null}
            <h2 className={style.propo_title}>Exposure</h2>

            <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
              <div className={style.propoformCountBtn}>
                <p> Number of Premises: </p>
                <div className="countGroupBtn">
                  <ButtonGroup size="small" aria-label="Small button group">
                    <Button
                      variant="contained"
                      onClick={() => handleConfirmation(null)}
                      disabled={formik.values?.warranty_premises.length < 2}
                    >
                      -
                    </Button>
                    <Button
                      style={{
                        pointerEvents: "none",
                        borderColor: "rgb(236 236 236)",
                      }}
                    >
                      {formik.values?.warranty_premises.length}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handlePlus}
                      disabled={
                        formik.values?.warranty_premises.length >= PremisesLimit
                      }
                    >
                      +
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            </Grid>

            <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
              <h2 className={style.formTitleh2}>
                11) Warranties as to property insured during term of insurance
                at all times when premises are closed.
              </h2>
              <Box sx={{mt: 1}}>
                <p className={style.htitleText + " " + style.noteText}>
                  <u>Note</u> : This section refers only to property described
                  in section 3 of the policy. If more than one premises, give
                  details of each.
                </p>
              </Box>
            </Grid>

            {formik.values?.warranty_premises.map((item, index) => (
              <>
                {" "}
                <Accordion
                  key={index}
                  defaultExpanded={false}
                  className="proposal_accordion"
                  style={
                    formik?.errors?.warranty_premises?.length
                      ? {borderColor: "#FF2116"}
                      : {}
                  }
                >
                  <div className="premiseAccordionDiv">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`warranty_premises${index + 1}-content`}
                      id={`warranty_premises${index + 1}-header`}
                    >
                      <Typography component="h4">
                        Premise {index + 1}
                      </Typography>
                    </AccordionSummary>
                    <Button
                      className={style.premiseCloseBtn}
                      variant="contained"
                      color="error"
                      onClick={() => handleConfirmation(index)}
                      disabled={formik.values?.warranty_premises?.length === 1}
                    >
                      <IoMdClose />
                    </Button>
                  </div>
                  <AccordionDetails>
                    <form
                      autoComplete="false"
                      autoSave="false"
                      onSubmit={handleCustomSubmit}
                    >
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Minimum proportion by value of property on premises
                            kept <strong> in locked safes and vaults </strong>
                            will be *
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`warranty_premises[${index}].minimum_locked_safes`}
                            id={`warranty_premises_${index}_minimum_locked_safes`}
                            value={
                              formik.values?.warranty_premises?.[index]
                                ?.minimum_locked_safes
                            }
                            // onChange={(e) =>
                            //   handleChangeAndUpdateTotal(
                            //     index,
                            //     "minimum_locked_safes",
                            //     e.target.value
                            //   )
                            // }
                            onChange={(e) => {
                              handleAmountFieldChange(
                                e,
                                index,
                                `warranty_premises[${index}].minimum_locked_safes`
                              );
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.warranty_premises?.[index]
                                ?.minimum_locked_safes &&
                              Boolean(
                                formik.errors?.warranty_premises?.[index]
                                  ?.minimum_locked_safes
                              )
                            }
                            helperText={
                              formik.touched?.warranty_premises?.[index]
                                ?.minimum_locked_safes &&
                              formik.errors?.warranty_premises?.[index]
                                ?.minimum_locked_safes
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Minimum proportion by value of property on premises
                            kept
                            <strong> in other locked safes and vaults </strong>
                            will be *
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`warranty_premises[${index}].minimum_other_locked_safes`}
                            id={`warranty_premises_${index}_minimum_other_locked_safes`}
                            value={
                              formik.values?.warranty_premises?.[index]
                                ?.minimum_other_locked_safes
                            }
                            // onChange={(e) =>
                            //   handleChangeAndUpdateTotal(
                            //     index,
                            //     "minimum_other_locked_safes",
                            //     e.target.value
                            //   )
                            // }
                            onChange={(e) => {
                              handleAmountFieldChange(
                                e,
                                index,
                                `warranty_premises[${index}].minimum_other_locked_safes`
                              );
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.warranty_premises?.[index]
                                ?.minimum_other_locked_safes &&
                              Boolean(
                                formik.errors?.warranty_premises?.[index]
                                  ?.minimum_other_locked_safes
                              )
                            }
                            helperText={
                              formik.touched?.warranty_premises?.[index]
                                ?.minimum_other_locked_safes &&
                              formik.errors?.warranty_premises?.[index]
                                ?.minimum_other_locked_safes
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Maximum proportion by value of property on premises
                            (Include window display)
                            <strong> out of safes and vaults </strong>will be *
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`warranty_premises[${index}].maximum_property_value`}
                            id={`warranty_premises_${index}_maximum_property_value`}
                            value={
                              formik.values?.warranty_premises?.[index]
                                ?.maximum_property_value
                            }
                            // onChange={(e) =>
                            //   handleChangeAndUpdateTotal(
                            //     index,
                            //     "maximum_property_value",
                            //     e.target.value
                            //   )
                            // }
                            onChange={(e) => {
                              handleAmountFieldChange(
                                e,
                                index,
                                `warranty_premises[${index}].maximum_property_value`
                              );
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.warranty_premises?.[index]
                                ?.maximum_property_value &&
                              Boolean(
                                formik.errors?.warranty_premises?.[index]
                                  ?.maximum_property_value
                              )
                            }
                            helperText={
                              formik.touched?.warranty_premises?.[index]
                                ?.maximum_property_value &&
                              formik.errors?.warranty_premises?.[index]
                                ?.maximum_property_value
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Minimum proportion by value of property kept
                            <strong>
                              {" "}
                              in safe deposit vault of a bank, Trust or Safe
                              Deposit Co.{" "}
                            </strong>
                            will be *
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            //placeH={"0 if None."}
                            placeH={"$"}
                            type="text"
                            name={`warranty_premises[${index}].maximum_property_value_in_bank`}
                            id={`warranty_premises_${index}_maximum_property_value_in_bank`}
                            value={
                              formik.values?.warranty_premises?.[index]
                                ?.maximum_property_value_in_bank
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              // formik.setFieldValue(
                              //   `warranty_premises[${index}].maximum_property_value_in_bank`,
                              //   value
                              // );

                              // handleChangeAndUpdateTotal(
                              //   index,
                              //   "maximum_property_value_in_bank",
                              //   value
                              // );
                              handleAmountFieldChange(
                                e,
                                index,
                                `warranty_premises[${index}].maximum_property_value_in_bank`
                              );
                              // If 0, clear name, address, and type
                              if (!value || Number(value) === 0) {
                                if (selectRefs.current[index]) {
                                  selectRefs.current[index].value = "";
                                }
                                formik.setFieldValue(
                                  `warranty_premises[${index}].name`,
                                  ""
                                );
                                formik.setFieldValue(
                                  `warranty_premises[${index}].address`,
                                  ""
                                );
                                formik.setFieldValue(
                                  `warranty_premises[${index}].type`,
                                  ""
                                );
                              }
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.warranty_premises?.[index]
                                ?.maximum_property_value_in_bank &&
                              Boolean(
                                formik.errors?.warranty_premises?.[index]
                                  ?.maximum_property_value_in_bank
                              )
                            }
                            helperText={
                              formik.touched?.warranty_premises?.[index]
                                ?.maximum_property_value_in_bank &&
                              formik.errors?.warranty_premises?.[index]
                                ?.maximum_property_value_in_bank
                            }
                          />
                        </Grid>
                      </Grid>
                      {normalizeCurrencyToNumber(
                        formik.values?.warranty_premises?.[index]
                          ?.maximum_property_value_in_bank
                      ) > 0 ? (
                        <Grid container spacing={2} sx={{mt: 3}}>
                          <Grid size={{xs: 12}}>
                            <div className={style.plusIconMain}>
                              <h3 className={style.htitleText}>
                                Names and Address of Banks, Trust or Safe
                                Deposit Co.’s
                              </h3>

                              <div
                                className={
                                  style.plusImgMain + " " + style.plusImgWidth
                                }
                              >
                                {/* Add Icon - Show only at index 0 and if the limit is not exceeded */}
                                {/* {formik.values.goods_in_the_custody.length < */}
                                {nameAddressTypeLimit && (
                                  <p
                                    style={{
                                      position: "inherit",
                                      display: "flex",
                                    }}
                                    onClick={() => handlePlusNameAddress(index)}
                                  >
                                    <img
                                      src={plusIcon}
                                      alt="Add"
                                      style={{marginRight: "5px"}}
                                    />
                                    Add
                                  </p>
                                )}
                              </div>
                            </div>
                          </Grid>

                          {formik.values?.warranty_premises[
                            index
                          ].name_address_type.map((address, addressIndex) => {
                            return (
                              <>
                                {addressIndex !== 0 && (
                                  <Box sx={{width: "100%", mt: 0, mb: 0}}>
                                    <Divider sx={{position: "relative"}}>
                                      <Chip
                                        label={`${addressIndex + 1}`}
                                        size="medium"
                                        clickable
                                        onDelete={() =>
                                          handleMinusNameAddress(
                                            index,
                                            addressIndex
                                          )
                                        }
                                      />
                                    </Divider>
                                  </Box>
                                )}
                                <Grid size={{xs: 12, md: 4}}>
                                  <Box sx={{color: "#000", mb: 1}}>
                                    <FormLabel
                                      className={style.labelText}
                                      sx={{mb: 1}}
                                    >
                                      Name
                                    </FormLabel>
                                  </Box>
                                  <GlobalTextField
                                    name={`warranty_premises[${index}].name_address_type[${addressIndex}].name`}
                                    id={`warranty_premises_${index}_name_address_type_${addressIndex}_name`}
                                    type="text"
                                    value={
                                      formik.values?.warranty_premises[index]
                                        .name_address_type[addressIndex]?.name
                                    }
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={Boolean(
                                      formik.touched?.warranty_premises?.[index]
                                        ?.name_address_type?.[addressIndex]
                                        ?.name &&
                                        formik.errors?.warranty_premises?.[
                                          index
                                        ]?.name_address_type?.[addressIndex]
                                          ?.name
                                    )}
                                    helperText={
                                      formik.touched?.warranty_premises?.[index]
                                        ?.name_address_type?.[addressIndex]
                                        ?.name &&
                                      formik.errors?.warranty_premises?.[index]
                                        ?.name_address_type?.[addressIndex]
                                        ?.name
                                    }
                                    disabled={
                                      !formik.values?.warranty_premises?.[index]
                                        ?.maximum_property_value_in_bank ||
                                      formik.values?.warranty_premises?.[index]
                                        ?.maximum_property_value_in_bank <= 0
                                    }
                                  />
                                </Grid>
                                <Grid size={{xs: 12, md: 4}}>
                                  <Box sx={{color: "#000", mb: 1}}>
                                    <FormLabel
                                      className={style.labelText}
                                      sx={{mb: 1}}
                                    >
                                      Address
                                    </FormLabel>
                                  </Box>

                                  <GlobalTextField
                                    name={`warranty_premises[${index}].name_address_type[${addressIndex}].address`}
                                    id={`warranty_premises_${index}_name_address_type_${addressIndex}_address`}
                                    type="text"
                                    value={
                                      formik.values?.warranty_premises[index]
                                        .name_address_type[addressIndex]
                                        ?.address
                                    }
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={Boolean(
                                      formik.touched?.warranty_premises?.[index]
                                        ?.name_address_type?.[addressIndex]
                                        ?.address &&
                                        formik.errors?.warranty_premises?.[
                                          index
                                        ]?.name_address_type?.[addressIndex]
                                          ?.address
                                    )}
                                    helperText={
                                      formik.touched?.warranty_premises?.[index]
                                        ?.name_address_type?.[addressIndex]
                                        ?.address &&
                                      formik.errors?.warranty_premises?.[index]
                                        ?.name_address_type?.[addressIndex]
                                        ?.address
                                    }
                                    disabled={
                                      !formik.values?.warranty_premises?.[index]
                                        ?.maximum_property_value_in_bank ||
                                      formik.values?.warranty_premises?.[index]
                                        ?.maximum_property_value_in_bank <= 0
                                    }
                                  />
                                </Grid>
                                <Grid size={{xs: 12, md: 4}}>
                                  <Box sx={{color: "#000", mb: 1}}>
                                    <FormLabel
                                      className={style.labelText}
                                      sx={{mb: 1}}
                                    >
                                      Banks, Trust or Safe Deposit
                                    </FormLabel>
                                  </Box>
                                  <GlobalSelectField
                                    ref={(el) =>
                                      (selectRefs.current[index] = el)
                                    }
                                    name={`warranty_premises[${index}].name_address_type[${addressIndex}].type`}
                                    labelId={`warranty_premises_${index}_name_address_type_${addressIndex}_type`}
                                    type="text"
                                    value={
                                      formik.values?.warranty_premises[index]
                                        .name_address_type[addressIndex]
                                        ?.type || ""
                                    }
                                    error={Boolean(
                                      formik.touched?.warranty_premises?.[index]
                                        ?.name_address_type?.[addressIndex]
                                        ?.type &&
                                        formik.errors?.warranty_premises?.[
                                          index
                                        ]?.name_address_type?.[addressIndex]
                                          ?.type
                                    )}
                                    helperText={
                                      formik.touched?.warranty_premises?.[index]
                                        ?.name_address_type?.[addressIndex]
                                        ?.type &&
                                      formik.errors?.warranty_premises?.[index]
                                        ?.name_address_type?.[addressIndex]
                                        ?.type
                                    }
                                    onChange={(e) =>
                                      formik.setFieldValue(
                                        `warranty_premises[${index}].name_address_type[${addressIndex}].type`,
                                        e.target.value
                                      )
                                    }
                                    onBlur={formik.handleBlur}
                                    menuItems={BankTrustSafeMenuItems}
                                    disabled={
                                      !formik.values?.warranty_premises?.[index]
                                        ?.maximum_property_value_in_bank ||
                                      formik.values?.warranty_premises?.[index]
                                        ?.maximum_property_value_in_bank <= 0
                                    }
                                    placeH={
                                      !formik.values?.warranty_premises?.[index]
                                        ?.maximum_property_value_in_bank ||
                                      formik.values?.warranty_premises?.[index]
                                        ?.maximum_property_value_in_bank <= 0
                                        ? "No Bank, Trust or Safe Deposit."
                                        : "Select"
                                    }
                                  />
                                </Grid>
                              </>
                            );
                          })}
                        </Grid>
                      ) : null}
                      {/* <Grid container spacing={2} sx={{ mt: 3 }}>
                        <Grid size={{ xs: 12 }}>
                          <h3 className={style.htitleText}>Total</h3>
                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`warranty_premises[${index}].total`}
                            id={`warranty_premises_${index}_total`}
                            value={
                              formik.values?.warranty_premises?.[index]?.total
                            }
                            onChange={() => { }}
                            error={Boolean(totalErrors?.[index])}
                            // error={totalErrors && Object.values(totalErrors).some((e) => e === true)}
                            helperText={
                              totalErrors?.[index] &&
                              "Total must be exactly 100%"
                            }
                            readOnly
                          />
                        </Grid>
                      </Grid> */}
                    </form>
                  </AccordionDetails>
                </Accordion>
                {formik?.errors?.warranty_premises?.length ? (
                  <small style={{color: "#FF2116"}}>
                    Mandatory Fields Are Missing!
                  </small>
                ) : null}
              </>
            ))}

            <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
              <h2 className={style.formTitleh2}>
                12) Inventories of all property wherever located. If more than
                one premises give details of each.
              </h2>
            </Grid>

            {formik.values?.inventories_premises.map((item, index) => (
              <>
                <Accordion
                  key={index}
                  defaultExpanded={false}
                  className="proposal_accordion"
                  style={
                    formik?.errors?.inventories_premises?.length
                      ? {borderColor: "#FF2116"}
                      : {}
                  }
                >
                  <div className="premiseAccordionDiv">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`inventories_premises${index + 1}-content`}
                      id={`inventories_premises${index + 1}-header`}
                    >
                      <Typography component="h4">
                        Premise {index + 1}
                      </Typography>
                    </AccordionSummary>
                    <Button
                      className={style.premiseCloseBtn}
                      variant="contained"
                      color="error"
                      onClick={() => handleConfirmation(index)}
                      disabled={
                        formik.values?.inventories_premises?.length === 1
                      }
                    >
                      <IoMdClose />
                    </Button>
                  </div>
                  <AccordionDetails>
                    <form
                      autoComplete="false"
                      autoSave="false"
                      onSubmit={handleCustomSubmit}
                    >
                      <Grid container spacing={2} sx={{mt: 0}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Last merchandise inventory was taken on
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            <FormLabel className={style.labelText} sx={{mb: 1}}>
                              Date *
                            </FormLabel>
                          </Box>
                          <GlobalDateField
                            name={`inventories_premises[${index}].last_merchandise_date`}
                            value={
                              formik.values?.inventories_premises[index]
                                .last_merchandise_date
                            }
                            onChange={(newValue) =>
                              formik.setFieldValue(
                                `inventories_premises[${index}].last_merchandise_date`,
                                newValue
                              )
                            }
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.last_merchandise_date &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.last_merchandise_date
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.last_merchandise_date &&
                              formik.errors?.inventories_premises?.[index]
                                ?.last_merchandise_date
                            }
                            disablePast={false}
                            disableFuture={true}
                            clearBtn={
                              formik.values?.inventories_premises[index]
                                .last_merchandise_date !== ""
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            <FormLabel className={style.labelText} sx={{mb: 1}}>
                              Inventory Amount *
                            </FormLabel>
                          </Box>

                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`inventories_premises[${index}].last_merchandise_amount`}
                            id={`inventories_premises_${index}_last_merchandise_amount`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.last_merchandise_amount
                            }
                            // onChange={(e) => {
                            //   const value = e.target.value;
                            //   formik.setFieldValue(
                            //     `inventories_premises[${index}].last_merchandise_amount`,
                            //     value
                            //   );
                            // }}
                            onChange={(e) => {
                              handleAmountFieldChange(
                                e,
                                index,
                                `inventories_premises[${index}].last_merchandise_amount`
                              );
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.last_merchandise_amount &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.last_merchandise_amount
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.last_merchandise_amount &&
                              formik.errors?.inventories_premises?.[index]
                                ?.last_merchandise_amount
                            }
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Previous merchandise inventory at least 6 months
                            prior to was taken on and was exactly
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            <FormLabel className={style.labelText} sx={{mb: 1}}>
                              Date *
                            </FormLabel>
                          </Box>
                          <GlobalDateField
                            name={`inventories_premises[${index}].previous_merchandise_date`}
                            value={
                              formik.values?.inventories_premises[index]
                                .previous_merchandise_date
                            }
                            onChange={(newValue) =>
                              formik.setFieldValue(
                                `inventories_premises[${index}].previous_merchandise_date`,
                                newValue
                              )
                            }
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.previous_merchandise_date &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.previous_merchandise_date
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.previous_merchandise_date &&
                              formik.errors?.inventories_premises?.[index]
                                ?.previous_merchandise_date
                            }
                            disablePast={false}
                            disableFuture={true}
                            clearBtn={
                              formik.values?.inventories_premises[index]
                                .previous_merchandise_date !== ""
                            }
                          />
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            <FormLabel className={style.labelText} sx={{mb: 1}}>
                              Inventory Amount *
                            </FormLabel>
                          </Box>

                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`inventories_premises[${index}].previous_merchandise_amount`}
                            id={`inventories_premises_${index}_previous_merchandise_amount`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.previous_merchandise_amount
                            }
                            // onChange={(e) => {
                            //   const value = e.target.value;
                            //   formik.setFieldValue(
                            //     `inventories_premises[${index}].previous_merchandise_amount`,
                            //     value
                            //   );
                            // }}
                            onChange={(e) => {
                              handleAmountFieldChange(
                                e,
                                index,
                                `inventories_premises[${index}].previous_merchandise_amount`
                              );
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.previous_merchandise_amount &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.previous_merchandise_amount
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.previous_merchandise_amount &&
                              formik.errors?.inventories_premises?.[index]
                                ?.previous_merchandise_amount
                            }
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Maximum amount of our stock during the last 12
                            months did not exceed
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <Box sx={{mb: 1}}>
                            <FormLabel className={style.labelText}>
                              Amount *
                            </FormLabel>
                          </Box>
                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`inventories_premises[${index}].maximum_stock_amount`}
                            id={`inventories_premises_${index}_maximum_stock_amount`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.maximum_stock_amount
                            }
                            // onChange={(e) => {
                            //   const value = e.target.value;
                            //   formik.setFieldValue(
                            //     `inventories_premises[${index}].maximum_stock_amount`,
                            //     value
                            //   );
                            // }}
                            onChange={(e) => {
                              handleAmountFieldChange(
                                e,
                                index,
                                `inventories_premises[${index}].maximum_stock_amount`
                              );
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.maximum_stock_amount &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.maximum_stock_amount
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.maximum_stock_amount &&
                              formik.errors?.inventories_premises?.[index]
                                ?.maximum_stock_amount
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Pawnbrokers: Amount loaned and unpaid plus accrued
                            interest at legal rate on pledged property
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <Box sx={{mb: 1}}>
                            <FormLabel className={style.labelText}>
                              Amount *
                            </FormLabel>
                          </Box>
                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`inventories_premises[${index}].pawnbrokers_amount`}
                            id={`inventories_premises_${index}_pawnbrokers_amount`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.pawnbrokers_amount
                            }
                            // onChange={(e) => {
                            //   const value = e.target.value;
                            //   formik.setFieldValue(
                            //     `inventories_premises[${index}].pawnbrokers_amount`,
                            //     value
                            //   );
                            // }}
                            onChange={(e) => {
                              handleAmountFieldChange(
                                e,
                                index,
                                `inventories_premises[${index}].pawnbrokers_amount`
                              );
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.pawnbrokers_amount &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.pawnbrokers_amount
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.pawnbrokers_amount &&
                              formik.errors?.inventories_premises?.[index]
                                ?.pawnbrokers_amount
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Estimated average daily amount of other people’s
                            property in our custody or control during the last
                            12 months, insured or uninsured was
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <Box sx={{mb: 1}}>
                            <FormLabel className={style.labelText}>
                              Amount *
                            </FormLabel>
                          </Box>
                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`inventories_premises[${index}].average_daily_amount`}
                            id={`inventories_premises_${index}_average_daily_amount`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.average_daily_amount
                            }
                            // onChange={(e) => {
                            //   const value = e.target.value;
                            //   formik.setFieldValue(
                            //     `inventories_premises[${index}].average_daily_amount`,
                            //     value
                            //   );
                            // }}
                            onChange={(e) => {
                              handleAmountFieldChange(
                                e,
                                index,
                                `inventories_premises[${index}].average_daily_amount`
                              );
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.average_daily_amount &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.average_daily_amount
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.average_daily_amount &&
                              formik.errors?.inventories_premises?.[index]
                                ?.average_daily_amount
                            }
                          />
                        </Grid>
                        <Grid size={{xs: 12}}>
                          <p
                            className={style.htitleText + " " + style.noteText}
                          >
                            <u>Note</u> : This should not include property
                            pledged with pawnbrokers nor to property of others
                            in the jewelry trade deposited with the insured for
                            safe custody only.
                          </p>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3
                            className={style.htitleText}
                            style={{fontWeight: "500"}}
                          >
                            Nature of stock as per last merchandise inventory
                            {/* as set forth in Section 15a (excepting pledges.) */}
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Loose diamonds (non-industrial) *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].loose_diamonds`}
                            id={`inventories_premises_${index}_loose_diamonds`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.loose_diamonds
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.loose_diamonds &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.loose_diamonds
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.loose_diamonds &&
                              formik.errors?.inventories_premises?.[index]
                                ?.loose_diamonds
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Pearls natural & cultured (mounted & unmounted) *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].pearls_natural_cultured`}
                            id={`inventories_premises_${index}_pearls_natural_cultured`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.pearls_natural_cultured
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.pearls_natural_cultured &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.pearls_natural_cultured
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.pearls_natural_cultured &&
                              formik.errors?.inventories_premises?.[index]
                                ?.pearls_natural_cultured
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Other unset precious stones *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].other_unset_precious_stone`}
                            id={`inventories_premises_${index}_other_unset_precious_stone`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.other_unset_precious_stone
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.other_unset_precious_stone &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.other_unset_precious_stone
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.other_unset_precious_stone &&
                              formik.errors?.inventories_premises?.[index]
                                ?.other_unset_precious_stone
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Unset semi-precious stones *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].unset_semi_precious_stone`}
                            id={`inventories_premises_${index}_unset_semi_precious_stone`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.unset_semi_precious_stone
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.unset_semi_precious_stone &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.unset_semi_precious_stone
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.unset_semi_precious_stone &&
                              formik.errors?.inventories_premises?.[index]
                                ?.unset_semi_precious_stone
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Jewelry mounted with diamonds and other precious
                            stones *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].jewelry_mounted`}
                            id={`inventories_premises_${index}_jewelry_mounted`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.jewelry_mounted
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.jewelry_mounted &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.jewelry_mounted
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.jewelry_mounted &&
                              formik.errors?.inventories_premises?.[index]
                                ?.jewelry_mounted
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Other jewelry including costume jewelers *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].other_jewelry`}
                            id={`inventories_premises_${index}_other_jewelry`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.other_jewelry
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.other_jewelry &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.other_jewelry
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.other_jewelry &&
                              formik.errors?.inventories_premises?.[index]
                                ?.other_jewelry
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Watches, watch cases, watch bracelets mounted with
                            diamonds or other precious stones *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].watches_with_diamonds`}
                            id={`inventories_premises_${index}_watches_with_diamonds`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.watches_with_diamonds
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.watches_with_diamonds &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.watches_with_diamonds
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.watches_with_diamonds &&
                              formik.errors?.inventories_premises?.[index]
                                ?.watches_with_diamonds
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Other watches, watch cases, movements, parts *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].other_watches`}
                            id={`inventories_premises_${index}_other_watches`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.other_watches
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.other_watches &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.other_watches
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.other_watches &&
                              formik.errors?.inventories_premises?.[index]
                                ?.other_watches
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Clocks (including cases, movements, parts) *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].clocks`}
                            id={`inventories_premises_${index}_clocks`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.clocks
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.clocks &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.clocks
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.clocks &&
                              formik.errors?.inventories_premises?.[index]
                                ?.clocks
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Silverware, Pewter, Plate & Stainless Steel *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].silveware_pewter_steels`}
                            id={`inventories_premises_${index}_silveware_pewter_steels`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.silveware_pewter_steels
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.silveware_pewter_steels &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.silveware_pewter_steels
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.silveware_pewter_steels &&
                              formik.errors?.inventories_premises?.[index]
                                ?.silveware_pewter_steels
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            Jewelers findings, unset mountings, material for
                            manufacture *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].jewelry_findings`}
                            id={`inventories_premises_${index}_jewelry_findings`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.jewelry_findings
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.jewelry_findings &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.jewelry_findings
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.jewelry_findings &&
                              formik.errors?.inventories_premises?.[index]
                                ?.jewelry_findings
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            All other stock (Describe) *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].all_other_stock`}
                            id={`inventories_premises_${index}_all_other_stock`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.all_other_stock
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.all_other_stock &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.all_other_stock
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.all_other_stock &&
                              formik.errors?.inventories_premises?.[index]
                                ?.all_other_stock
                            }
                          />

                          {/* {sum_stock_percentage_err?.[index] ? (
                            <GlobalErrorMsgBox
                              errMessage={`The total of stock percentages must be equal to 100%. It can't exceed 100%.`}
                              margin={false}
                            />
                          ) : null} */}
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>Describe here</h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            //placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].stock_describe`}
                            id={`inventories_premises_${index}_stock_describe`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.stock_describe
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.stock_describe &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.stock_describe
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.stock_describe &&
                              formik.errors?.inventories_premises?.[index]
                                ?.stock_describe
                            }
                          />

                          {/* {sum_stock_percentage_err?.[index] ? (
                            <GlobalErrorMsgBox
                              errMessage={`The total of stock percentages must be equal to 100%. It can't exceed 100%.`}
                              margin={false}
                            />
                          ) : null} */}
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3
                            className={style.htitleText}
                            style={{fontWeight: "500"}}
                          >
                            Low valued stock as per last merchandise inventory
                          </h3>
                        </Grid>

                        <Grid size={{xs: 12, md: 4}}>
                          <Box sx={{color: "#000", mb: 1}}>
                            <h3 className={style.htitleText}>
                              The percentage of jewelry *
                            </h3>
                          </Box>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].jewelry_percentage`}
                            id={`inventories_premises_${index}_jewelry_percentage`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.jewelry_percentage
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.jewelry_percentage &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.jewelry_percentage
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.jewelry_percentage &&
                              formik.errors?.inventories_premises?.[index]
                                ?.jewelry_percentage
                            }
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            The percentage of watches & clocks *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="%"
                            type="text"
                            name={`inventories_premises[${index}].watches_clocks_percentage`}
                            id={`inventories_premises_${index}_watches_clocks_percentage`}
                            value={
                              formik.values?.inventories_premises?.[index]
                                ?.watches_clocks_percentage
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.inventories_premises?.[index]
                                ?.watches_clocks_percentage &&
                              Boolean(
                                formik.errors?.inventories_premises?.[index]
                                  ?.watches_clocks_percentage
                              )
                            }
                            helperText={
                              formik.touched?.inventories_premises?.[index]
                                ?.watches_clocks_percentage &&
                              formik.errors?.inventories_premises?.[index]
                                ?.watches_clocks_percentage
                            }
                          />
                          {/* {sum_jewelry_watches_err?.[index] ? (
                            <GlobalErrorMsgBox
                              errMessage={`The total of 'Jewelry %' and 'Watches/Clocks %' in Premise must be equal to 100%. It can't exceed 100%.`}
                              margin={false}
                            />
                          ) : null} */}
                          {sum_stock_percentage_err?.[index] ? (
                            <GlobalErrorMsgBox
                              errMessage={`The total of stock percentages must be equal to 100%. It can't exceed 100%.`}
                              margin={false}
                            />
                          ) : null}
                        </Grid>
                      </Grid>
                    </form>
                  </AccordionDetails>
                </Accordion>
                {formik?.errors?.inventories_premises?.length ? (
                  <small style={{color: "#FF2116"}}>
                    Mandatory Fields Are Missing!
                  </small>
                ) : null}
              </>
            ))}
            <Grid size={{xs: 12, md: 12}} sx={{mt: 2}}>
              <h2 className={style.formTitleh2}>
                13) Property other than stock and other people’s goods.
              </h2>
            </Grid>

            {formik.values?.property_premises.map((item, index) => (
              <>
                <Accordion
                  key={index}
                  defaultExpanded={false}
                  className="proposal_accordion"
                  style={
                    formik?.errors?.property_premises?.length
                      ? {borderColor: "#FF2116"}
                      : {}
                  }
                >
                  <div className="premiseAccordionDiv">
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`property_premises${index + 1}-content`}
                      id={`property_premises${index + 1}-header`}
                    >
                      <Typography component="h4">
                        Premise {index + 1}
                      </Typography>
                    </AccordionSummary>
                    <Button
                      className={style.premiseCloseBtn}
                      variant="contained"
                      color="error"
                      onClick={() => handleConfirmation(index)}
                      disabled={formik.values?.property_premises?.length === 1}
                    >
                      <IoMdClose />
                    </Button>
                  </div>
                  <AccordionDetails>
                    <form
                      autoComplete="false"
                      autoSave="false"
                      onSubmit={handleCustomSubmit}
                    >
                      <Grid container spacing={2} sx={{mt: 3}}>
                        <Grid size={{xs: 12}}>
                          <h3 className={style.htitleText}>
                            The actual cash value (cost to replace with material
                            of like kind & quality, less depreciation) of
                            property on which insurance has been requested is
                            estimated to be: *
                          </h3>
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                          <GlobalTextField
                            placeH="$"
                            type="text"
                            name={`property_premises[${index}].cash_value`}
                            id={`property_premises_${index}_cash_value`}
                            value={
                              formik.values?.property_premises?.[index]
                                ?.cash_value
                            }
                            // onChange={(e) => {
                            //   const value = e.target.value;
                            //   formik.setFieldValue(
                            //     `property_premises[${index}].cash_value`,
                            //     value
                            //   );
                            //   if (!value || Number(value) === 0) {
                            //     formik.setFieldValue(
                            //       `property_premises[${index}].furniture_other`,
                            //       ""
                            //     );
                            //     formik.setFieldValue(
                            //       `property_premises[${index}].tentants_improvements`,
                            //       ""
                            //     );
                            //   }
                            // }}

                            onChange={(e) => {
                              handleAmountFieldChange(
                                e,
                                index,
                                `property_premises[${index}].cash_value`
                              );
                              const value = e.target.value;
                              if (!value || Number(value) === 0) {
                                formik.setFieldValue(
                                  `property_premises[${index}].furniture_other`,
                                  ""
                                );
                                formik.setFieldValue(
                                  `property_premises[${index}].tentants_improvements`,
                                  ""
                                );
                              }
                            }}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched?.property_premises?.[index]
                                ?.cash_value &&
                              Boolean(
                                formik.errors?.property_premises?.[index]
                                  ?.cash_value
                              )
                            }
                            helperText={
                              formik.touched?.property_premises?.[index]
                                ?.cash_value &&
                              formik.errors?.property_premises?.[index]
                                ?.cash_value
                            }
                          />
                        </Grid>
                      </Grid>

                      {/* {Number(
                      formik.values?.property_premises?.[index]
                        ?.cash_value
                    ) > 0 ? <> */}

                      {formik.values?.property_premises?.[index]?.cash_value !==
                        "" &&
                      formik.values?.property_premises?.[index]?.cash_value !==
                        "$0" ? (
                        <>
                          <Grid container spacing={2} sx={{mt: 3}}>
                            <Grid size={{xs: 12}}>
                              <h3 className={style.htitleText}>
                                Furniture, fixtures, tools, machinery, &
                                fittings *
                              </h3>
                            </Grid>
                            <Grid size={{xs: 12, md: 4}}>
                              <GlobalTextField
                                placeH={
                                  !formik.values?.property_premises?.[index]
                                    ?.cash_value ||
                                  formik.values?.property_premises?.[index]
                                    ?.cash_value <= 0
                                    ? "No Actual Cash."
                                    : "%"
                                }
                                type="text"
                                name={`property_premises[${index}].furniture_other`}
                                id={`property_premises_${index}_furniture_other`}
                                value={
                                  formik.values?.property_premises?.[index]
                                    ?.furniture_other
                                }
                                // onChange={formik.handleChange}
                                onChange={(e) =>
                                  handlePropertyChange(
                                    e,
                                    index,
                                    "furniture_other"
                                  )
                                }
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched?.property_premises?.[index]
                                    ?.furniture_other &&
                                  Boolean(
                                    formik.errors?.property_premises?.[index]
                                      ?.furniture_other
                                  )
                                }
                                helperText={
                                  formik.touched?.property_premises?.[index]
                                    ?.furniture_other &&
                                  formik.errors?.property_premises?.[index]
                                    ?.furniture_other
                                }
                                disabled={
                                  !formik.values?.property_premises?.[index]
                                    ?.cash_value ||
                                  formik.values?.property_premises?.[index]
                                    ?.cash_value <= 0
                                }
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} sx={{mt: 3}}>
                            <Grid size={{xs: 12}}>
                              <h3 className={style.htitleText}>
                                Tenant’s improvements & betterments to
                                building(s) *
                              </h3>
                            </Grid>
                            <Grid size={{xs: 12, md: 4}}>
                              <GlobalTextField
                                placeH={
                                  !formik.values?.property_premises?.[index]
                                    ?.cash_value ||
                                  formik.values?.property_premises?.[index]
                                    ?.cash_value <= 0
                                    ? "No Actual Cash."
                                    : "%"
                                }
                                type="text"
                                name={`property_premises[${index}].tentants_improvements`}
                                id={`property_premises_${index}_tentants_improvements`}
                                value={
                                  formik.values?.property_premises?.[index]
                                    ?.tentants_improvements
                                }
                                // onChange={formik.handleChange}
                                onChange={(e) =>
                                  handlePropertyChange(
                                    e,
                                    index,
                                    "tentants_improvements"
                                  )
                                }
                                onBlur={formik.handleBlur}
                                error={
                                  formik.touched?.property_premises?.[index]
                                    ?.tentants_improvements &&
                                  Boolean(
                                    formik.errors?.property_premises?.[index]
                                      ?.tentants_improvements
                                  )
                                }
                                helperText={
                                  formik.touched?.property_premises?.[index]
                                    ?.tentants_improvements &&
                                  formik.errors?.property_premises?.[index]
                                    ?.tentants_improvements
                                }
                                disabled={
                                  !formik.values?.property_premises?.[index]
                                    ?.cash_value ||
                                  formik.values?.property_premises?.[index]
                                    ?.cash_value <= 0
                                }
                              />

                              {typeof formik.errors?.property_premises?.[
                                index
                              ] === "string" ? (
                                <GlobalErrorMsgBox
                                  errMessage={
                                    formik.errors?.property_premises?.[index]
                                  }
                                  margin={false}
                                />
                              ) : null}
                            </Grid>
                          </Grid>
                        </>
                      ) : null}
                    </form>
                  </AccordionDetails>
                </Accordion>
                {formik?.errors?.property_premises?.length ? (
                  <small style={{color: "#FF2116"}}>
                    Mandatory Fields Are Missing!
                  </small>
                ) : null}
              </>
            ))}
          </Box>
        </motion.div>

        <NewProposalFooter
          submitForm={handleCustomSubmit}
          leftGridWidth={leftGridWidth}
          nextPage={
            formik.values?.warranty_premises?.[0]?.minimum_locked_safes != "" &&
            formik.values?.inventories_premises[0].last_merchandise_date !=
              "" &&
            formik.values?.property_premises?.[0]?.cash_value != "" &&
            !formik.dirty &&
            propStep5DataMemoize !== null
          }
          handleSaveDraft={handleSaveDraft}
          disableDraft={disableDraft}
        />
        <GlobalModal
          open={openModal}
          maxWidth="sm"
          handleClose={() => setOpenModal(false)}
          aria-labelledby="step-5-confirm"
          closeIcon={true}
          title={"Are you sure?"}
          dialogTitleClass={style.claimPopTitle}
          disableBackdropClick={false}
          dialogContent={
            <Grid container spacing={0}>
              <Grid size={{xs: 12, md: 12}} sx={{textAlign: "center", mb: 3}}>
                {/* <BiErrorCircle color="#FF2116" size={40}/> */}
                <p>{modalContent}</p>
              </Grid>
              <Grid
                size={{xs: 12, md: 12}}
                sx={{textAlign: "center"}}
                className={style.consentContentBtn}
              >
                <Button
                  variant="contained"
                  sx={{mr: 2}}
                  onClick={() => handleRemove(true)}
                >
                  YES
                </Button>
                <Button variant="contained" onClick={() => handleRemove(false)}>
                  NO
                </Button>
              </Grid>
            </Grid>
          }
        ></GlobalModal>
      </section>
    </>
  );
};

export default StepFiveForm;
